const buttonPalette = (tokens) => {
    return {
        padding: tokens.buttonPadding,
        borderWidth: tokens.buttonBorderWidth,
        spaceBetween: tokens.buttonSpaceBetween,
        radius: tokens.buttonRadius,
        height: tokens.buttonHeightDefault,
        font: {
            family: tokens.buttonFontFamily,
            size: tokens.buttonFontSize,
            weight: tokens.buttonFontWeight,
            lineHeight: tokens.buttonLineHeight,
            letterSpacing: tokens.buttonLetterSpacing
        },
        actionBar: {
            background: {
                default: tokens.buttonColorBgActionBarDefault,
                hover: tokens.buttonColorBgActionBarHover,
                focus: tokens.buttonColorBgActionBarFocus,
                disabled: tokens.buttonColorBgDisabled
            },
            border: {
                default: tokens.buttonColorBorderActionBarDefault,
                hover: tokens.buttonColorBorderActionBarHover,
                focus: tokens.buttonColorBorderActionBarFocus,
                disabled: tokens.buttonColorBorderDisabled
            },
            text: tokens.buttonColorTextActionBar
        },
        interactive: {
            subtle: {
                background: {
                    default: tokens.buttonColorBgSubtleDefault,
                    hover: tokens.buttonColorBgSubtleHover,
                    focus: tokens.buttonColorBgSubtleFocus,
                    disabled: tokens.buttonColorBgDisabled,
                    selected: {
                        default: tokens.buttonColorBgSubtleSelectedDefault,
                        hover: tokens.buttonColorBgSubtleSelectedHover
                    }
                },
                border: {
                    default: tokens.buttonColorBorderSubtleDefault,
                    hover: tokens.buttonColorBorderSubtleHover,
                    focus: tokens.buttonColorBorderSubtleFocus,
                    disabled: tokens.buttonColorBorderDisabled,
                    selected: {
                        default: tokens.buttonColorBorderSubtleSelectedDefault,
                        hover: tokens.buttonColorBorderSubtleSelectedHover
                    }
                },
                text: tokens.buttonColorTextSubtle,
                icon: {
                    default: tokens.iconColorInteractiveCtaSubtleDefault,
                    disabled: tokens.iconColorInteractiveCtaDisabled
                }
            },
            emphasis: {
                background: {
                    default: tokens.buttonColorBgEmphasisDefault,
                    hover: tokens.buttonColorBgEmphasisHover,
                    focus: tokens.buttonColorBgEmphasisFocus,
                    disabled: tokens.buttonColorBgDisabled,
                    selected: {
                        default: tokens.buttonColorBgEmphasisSelectedDefault,
                        hover: tokens.buttonColorBgEmphasisSelectedHover
                    }
                },
                border: {
                    default: tokens.buttonColorBorderEmphasisDefault,
                    hover: tokens.buttonColorBorderEmphasisHover,
                    focus: tokens.buttonColorBorderEmphasisFocus,
                    disabled: tokens.buttonColorBorderDisabled,
                    selected: {
                        default: tokens.buttonColorBorderEmphasisSelectedDefault,
                        hover: tokens.buttonColorBorderEmphasisSelectedHover
                    }
                },
                text: tokens.buttonColorTextEmphasis,
                icon: {
                    default: tokens.iconColorInteractiveCtaEmphasisDefault,
                    disabled: tokens.iconColorInteractiveCtaDisabled
                }
            },
            neutral: {
                background: {
                    default: tokens.buttonColorBgNeutralDefault,
                    hover: tokens.buttonColorBgNeutralHover,
                    focus: tokens.buttonColorBgNeutralFocus,
                    disabled: tokens.buttonColorBgDisabled,
                    selected: {
                        default: tokens.buttonColorBgNeutralSelectedDefault,
                        hover: tokens.buttonColorBgNeutralSelectedHover
                    }
                },
                border: {
                    default: tokens.buttonColorBorderNeutralDefault,
                    hover: tokens.buttonColorBorderNeutralHover,
                    focus: tokens.buttonColorBorderNeutralFocus,
                    disabled: tokens.buttonColorBorderDisabled,
                    selected: {
                        default: tokens.buttonColorBorderNeutralSelectedDefault,
                        hover: tokens.buttonColorBorderNeutralSelectedHover
                    }
                },
                text: tokens.buttonColorTextNeutral,
                icon: {
                    default: tokens.iconColorInteractiveCtaNeutralDefault,
                    disabled: tokens.iconColorInteractiveCtaDisabled
                }
            }
        }
    };
};
export default buttonPalette;
//# sourceMappingURL=button.js.map